import React, { useEffect, useState } from "react";
import { Outlet, redirect, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";

// css
import styles from "./mainLayout.module.scss";

import Sidebar from "../../components/Header/sidebar/Sidebar";
import InactiveSessionLogoutPopup from "components/Modals/InactiveSessionLogoutPopup/Index";
import { useSelector } from "react-redux";

const MainLayout = () => {
  const userInfo = useSelector((state) => state.auth.userInfo)
  const [sidebar, setSidebar] = useState();
  const location = useLocation();
  const navigate = useNavigate()

  useEffect(() => {
    if (!userInfo?.is_on_board_complete) {
      navigate('/onboard')
    }

  }, [userInfo])
  return (
    <>
      <InactiveSessionLogoutPopup />
      <div className={`${styles.mainLayout} d-flex align-items-start`}>
        <Sidebar sidebar={sidebar} setSidebar={setSidebar} />
        <main
          className={`${styles.MainBody} ms-auto MainBody position-relative`}
        >
          <Header sidebar={sidebar} setSidebar={setSidebar} />
          <Outlet />
        </main>
      </div>
    </>
  );
};
export default MainLayout;
